/* @generated */
// prettier-ignore
if (Intl.NumberFormat && typeof Intl.NumberFormat.__addLocaleData === 'function') {
  Intl.NumberFormat.__addLocaleData({
  "data": {
    "currencies": {
      "AED": {
        "displayName": {
          "other": "Dirham UAE"
        },
        "narrow": "AED",
        "symbol": "AED"
      },
      "AFN": {
        "displayName": {
          "other": "Afghani Afghanistan"
        },
        "narrow": "؋",
        "symbol": "AFN"
      },
      "ALL": {
        "displayName": {
          "other": "Lek Albania"
        },
        "narrow": "ALL",
        "symbol": "ALL"
      },
      "AMD": {
        "displayName": {
          "other": "Dram Armenia"
        },
        "narrow": "֏",
        "symbol": "AMD"
      },
      "ANG": {
        "displayName": {
          "other": "Guilder Antillen Belanda"
        },
        "narrow": "ANG",
        "symbol": "ANG"
      },
      "AOA": {
        "displayName": {
          "other": "Kwanza Angola"
        },
        "narrow": "Kz",
        "symbol": "AOA"
      },
      "ARS": {
        "displayName": {
          "other": "Peso Argentina"
        },
        "narrow": "$",
        "symbol": "ARS"
      },
      "AUD": {
        "displayName": {
          "other": "Dolar Australia"
        },
        "narrow": "$",
        "symbol": "A$"
      },
      "AWG": {
        "displayName": {
          "other": "Florin Aruba"
        },
        "narrow": "AWG",
        "symbol": "AWG"
      },
      "AZN": {
        "displayName": {
          "other": "Manat Azerbaijan"
        },
        "narrow": "₼",
        "symbol": "AZN"
      },
      "BAM": {
        "displayName": {
          "other": "Mark Boleh Tukar Bosnia-Herzegovina"
        },
        "narrow": "KM",
        "symbol": "BAM"
      },
      "BBD": {
        "displayName": {
          "other": "Dolar Barbados"
        },
        "narrow": "$",
        "symbol": "BBD"
      },
      "BDT": {
        "displayName": {
          "other": "Taka Bangladesh"
        },
        "narrow": "৳",
        "symbol": "BDT"
      },
      "BGN": {
        "displayName": {
          "other": "Lev Bulgaria"
        },
        "narrow": "BGN",
        "symbol": "BGN"
      },
      "BHD": {
        "displayName": {
          "other": "Dinar Bahrain"
        },
        "narrow": "BHD",
        "symbol": "BHD"
      },
      "BIF": {
        "displayName": {
          "other": "Franc Burundi"
        },
        "narrow": "BIF",
        "symbol": "BIF"
      },
      "BMD": {
        "displayName": {
          "other": "Dolar Bermuda"
        },
        "narrow": "$",
        "symbol": "BMD"
      },
      "BND": {
        "displayName": {
          "other": "Dolar Brunei"
        },
        "narrow": "$",
        "symbol": "BND"
      },
      "BOB": {
        "displayName": {
          "other": "Boliviano Bolivia"
        },
        "narrow": "Bs",
        "symbol": "BOB"
      },
      "BRL": {
        "displayName": {
          "other": "Real Brazil"
        },
        "narrow": "R$",
        "symbol": "R$"
      },
      "BSD": {
        "displayName": {
          "other": "Dolar Bahamas"
        },
        "narrow": "$",
        "symbol": "BSD"
      },
      "BTN": {
        "displayName": {
          "other": "Ngultrum Bhutan"
        },
        "narrow": "BTN",
        "symbol": "BTN"
      },
      "BWP": {
        "displayName": {
          "other": "Pula Botswana"
        },
        "narrow": "P",
        "symbol": "BWP"
      },
      "BYN": {
        "displayName": {
          "other": "Rubel Belarus"
        },
        "narrow": "р.",
        "symbol": "BYN"
      },
      "BYR": {
        "displayName": {
          "other": "Rubel Belarus (2000–2016)"
        },
        "narrow": "BYR",
        "symbol": "BYR"
      },
      "BZD": {
        "displayName": {
          "other": "Dolar Belize"
        },
        "narrow": "$",
        "symbol": "BZD"
      },
      "CAD": {
        "displayName": {
          "other": "Dolar Kanada"
        },
        "narrow": "$",
        "symbol": "CAD"
      },
      "CDF": {
        "displayName": {
          "other": "Franc Congo"
        },
        "narrow": "CDF",
        "symbol": "CDF"
      },
      "CHF": {
        "displayName": {
          "other": "Franc Switzerland"
        },
        "narrow": "CHF",
        "symbol": "CHF"
      },
      "CLP": {
        "displayName": {
          "other": "Peso Chile"
        },
        "narrow": "$",
        "symbol": "CLP"
      },
      "CNH": {
        "displayName": {
          "other": "Yuan China (luar pesisir)"
        },
        "narrow": "CNH",
        "symbol": "CNH"
      },
      "CNY": {
        "displayName": {
          "other": "Yuan Cina"
        },
        "narrow": "¥",
        "symbol": "CN¥"
      },
      "COP": {
        "displayName": {
          "other": "Peso Colombia"
        },
        "narrow": "$",
        "symbol": "COP"
      },
      "CRC": {
        "displayName": {
          "other": "Colon Costa Rica"
        },
        "narrow": "₡",
        "symbol": "CRC"
      },
      "CUC": {
        "displayName": {
          "other": "Peso Boleh Tukar Cuba"
        },
        "narrow": "$",
        "symbol": "CUC"
      },
      "CUP": {
        "displayName": {
          "other": "Peso Cuba"
        },
        "narrow": "$",
        "symbol": "CUP"
      },
      "CVE": {
        "displayName": {
          "other": "Escudo Tanjung Verde"
        },
        "narrow": "CVE",
        "symbol": "CVE"
      },
      "CZK": {
        "displayName": {
          "other": "Koruna Republik Czech"
        },
        "narrow": "Kč",
        "symbol": "CZK"
      },
      "DJF": {
        "displayName": {
          "other": "Franc Djibouti"
        },
        "narrow": "DJF",
        "symbol": "DJF"
      },
      "DKK": {
        "displayName": {
          "other": "Krone Denmark"
        },
        "narrow": "kr",
        "symbol": "DKK"
      },
      "DOP": {
        "displayName": {
          "other": "Peso Dominican"
        },
        "narrow": "$",
        "symbol": "DOP"
      },
      "DZD": {
        "displayName": {
          "other": "Dinar Algeria"
        },
        "narrow": "DZD",
        "symbol": "DZD"
      },
      "EGP": {
        "displayName": {
          "other": "Paun Mesir"
        },
        "narrow": "E£",
        "symbol": "EGP"
      },
      "ERN": {
        "displayName": {
          "other": "Nakfa Eritrea"
        },
        "narrow": "ERN",
        "symbol": "ERN"
      },
      "ESP": {
        "displayName": {
        },
        "narrow": "₧",
        "symbol": "ESP"
      },
      "ETB": {
        "displayName": {
          "other": "Birr Ethiopia"
        },
        "narrow": "ETB",
        "symbol": "ETB"
      },
      "EUR": {
        "displayName": {
          "other": "Euro"
        },
        "narrow": "€",
        "symbol": "€"
      },
      "FJD": {
        "displayName": {
          "other": "Dolar Fiji"
        },
        "narrow": "$",
        "symbol": "FJD"
      },
      "FKP": {
        "displayName": {
          "other": "Paun Kepulauan Falkland"
        },
        "narrow": "£",
        "symbol": "FKP"
      },
      "GBP": {
        "displayName": {
          "other": "Paun British"
        },
        "narrow": "£",
        "symbol": "£"
      },
      "GEL": {
        "displayName": {
          "other": "Lari Georgia"
        },
        "narrow": "₾",
        "symbol": "GEL"
      },
      "GHS": {
        "displayName": {
          "other": "Cedi Ghana"
        },
        "narrow": "GH₵",
        "symbol": "GHS"
      },
      "GIP": {
        "displayName": {
          "other": "Paun Gibraltar"
        },
        "narrow": "£",
        "symbol": "GIP"
      },
      "GMD": {
        "displayName": {
          "other": "Dalasi Gambia"
        },
        "narrow": "GMD",
        "symbol": "GMD"
      },
      "GNF": {
        "displayName": {
          "other": "Franc Guinea"
        },
        "narrow": "FG",
        "symbol": "GNF"
      },
      "GTQ": {
        "displayName": {
          "other": "Quetzal Guatemala"
        },
        "narrow": "Q",
        "symbol": "GTQ"
      },
      "GYD": {
        "displayName": {
          "other": "Dolar Guyana"
        },
        "narrow": "$",
        "symbol": "GYD"
      },
      "HKD": {
        "displayName": {
          "other": "Dolar Hong Kong"
        },
        "narrow": "$",
        "symbol": "HK$"
      },
      "HNL": {
        "displayName": {
          "other": "Lempira Honduras"
        },
        "narrow": "L",
        "symbol": "HNL"
      },
      "HRK": {
        "displayName": {
          "other": "Kuna Croatia"
        },
        "narrow": "kn",
        "symbol": "HRK"
      },
      "HTG": {
        "displayName": {
          "other": "Gourde Haiti"
        },
        "narrow": "HTG",
        "symbol": "HTG"
      },
      "HUF": {
        "displayName": {
          "other": "Forint Hungary"
        },
        "narrow": "Ft",
        "symbol": "HUF"
      },
      "IDR": {
        "displayName": {
          "other": "Rupiah Indonesia"
        },
        "narrow": "Rp",
        "symbol": "IDR"
      },
      "ILS": {
        "displayName": {
          "other": "Syekel baharu Israel"
        },
        "narrow": "₪",
        "symbol": "₪"
      },
      "INR": {
        "displayName": {
          "other": "Rupee India"
        },
        "narrow": "₹",
        "symbol": "₹"
      },
      "IQD": {
        "displayName": {
          "other": "Dinar Iraq"
        },
        "narrow": "IQD",
        "symbol": "IQD"
      },
      "IRR": {
        "displayName": {
          "other": "Rial Iran"
        },
        "narrow": "IRR",
        "symbol": "IRR"
      },
      "ISK": {
        "displayName": {
          "other": "Krona Iceland"
        },
        "narrow": "kr",
        "symbol": "ISK"
      },
      "JMD": {
        "displayName": {
          "other": "Dolar Jamaica"
        },
        "narrow": "$",
        "symbol": "JMD"
      },
      "JOD": {
        "displayName": {
          "other": "Dinar Jordan"
        },
        "narrow": "JOD",
        "symbol": "JOD"
      },
      "JPY": {
        "displayName": {
          "other": "Yen Jepun"
        },
        "narrow": "¥",
        "symbol": "JP¥"
      },
      "KES": {
        "displayName": {
          "other": "Syiling Kenya"
        },
        "narrow": "KES",
        "symbol": "KES"
      },
      "KGS": {
        "displayName": {
          "other": "Som Kyrgystani"
        },
        "narrow": "KGS",
        "symbol": "KGS"
      },
      "KHR": {
        "displayName": {
          "other": "Riel Kemboja"
        },
        "narrow": "៛",
        "symbol": "KHR"
      },
      "KMF": {
        "displayName": {
          "other": "Franc Comoria"
        },
        "narrow": "CF",
        "symbol": "KMF"
      },
      "KPW": {
        "displayName": {
          "other": "Won Korea Utara"
        },
        "narrow": "₩",
        "symbol": "KPW"
      },
      "KRW": {
        "displayName": {
          "other": "Won Korea Selatan"
        },
        "narrow": "₩",
        "symbol": "₩"
      },
      "KWD": {
        "displayName": {
          "other": "Dinar Kuwait"
        },
        "narrow": "KWD",
        "symbol": "KWD"
      },
      "KYD": {
        "displayName": {
          "other": "Dolar Kepulauan Cayman"
        },
        "narrow": "$",
        "symbol": "KYD"
      },
      "KZT": {
        "displayName": {
          "other": "Tenge Kazakhstan"
        },
        "narrow": "₸",
        "symbol": "KZT"
      },
      "LAK": {
        "displayName": {
          "other": "Kip Laos"
        },
        "narrow": "₭",
        "symbol": "LAK"
      },
      "LBP": {
        "displayName": {
          "other": "Paun Lubnan"
        },
        "narrow": "L£",
        "symbol": "LBP"
      },
      "LKR": {
        "displayName": {
          "other": "Rupee Sri Lanka"
        },
        "narrow": "Rs",
        "symbol": "LKR"
      },
      "LRD": {
        "displayName": {
          "other": "Dolar Liberia"
        },
        "narrow": "$",
        "symbol": "LRD"
      },
      "LSL": {
        "displayName": {
          "other": "Loti Lesotho"
        },
        "narrow": "LSL",
        "symbol": "LSL"
      },
      "LTL": {
        "displayName": {
          "other": "Litas Lithuania"
        },
        "narrow": "Lt",
        "symbol": "LTL"
      },
      "LVL": {
        "displayName": {
          "other": "Lats Latvia"
        },
        "narrow": "Ls",
        "symbol": "LVL"
      },
      "LYD": {
        "displayName": {
          "other": "Dinar Libya"
        },
        "narrow": "LYD",
        "symbol": "LYD"
      },
      "MAD": {
        "displayName": {
          "other": "Dirham Maghribi"
        },
        "narrow": "MAD",
        "symbol": "MAD"
      },
      "MDL": {
        "displayName": {
          "other": "Leu Moldova"
        },
        "narrow": "MDL",
        "symbol": "MDL"
      },
      "MGA": {
        "displayName": {
          "other": "Ariary Malagasy"
        },
        "narrow": "Ar",
        "symbol": "MGA"
      },
      "MGF": {
        "displayName": {
          "other": "Franc Malagasy"
        },
        "narrow": "MGF",
        "symbol": "MGF"
      },
      "MKD": {
        "displayName": {
          "other": "Denar Macedonia"
        },
        "narrow": "MKD",
        "symbol": "MKD"
      },
      "MMK": {
        "displayName": {
          "other": "Kyat Myanma"
        },
        "narrow": "K",
        "symbol": "MMK"
      },
      "MNT": {
        "displayName": {
          "other": "Tugrik Mongolia"
        },
        "narrow": "₮",
        "symbol": "MNT"
      },
      "MOP": {
        "displayName": {
          "other": "Pataca Macau"
        },
        "narrow": "MOP",
        "symbol": "MOP"
      },
      "MRO": {
        "displayName": {
          "other": "Ouguiya Mauritania (1973–2017)"
        },
        "narrow": "MRO",
        "symbol": "MRO"
      },
      "MRU": {
        "displayName": {
          "other": "Ouguiya Mauritania"
        },
        "narrow": "MRU",
        "symbol": "MRU"
      },
      "MUR": {
        "displayName": {
          "other": "Rupee Mauritius"
        },
        "narrow": "Rs",
        "symbol": "MUR"
      },
      "MVR": {
        "displayName": {
          "other": "Rufiyaa Maldives"
        },
        "narrow": "MVR",
        "symbol": "MVR"
      },
      "MWK": {
        "displayName": {
          "other": "Kwacha Malawi"
        },
        "narrow": "MWK",
        "symbol": "MWK"
      },
      "MXN": {
        "displayName": {
          "other": "Peso Mexico"
        },
        "narrow": "$",
        "symbol": "MXN"
      },
      "MYR": {
        "displayName": {
          "other": "Ringgit Malaysia"
        },
        "narrow": "RM",
        "symbol": "RM"
      },
      "MZE": {
        "displayName": {
          "other": "Escudo Mozambique"
        },
        "narrow": "MZE",
        "symbol": "MZE"
      },
      "MZM": {
        "displayName": {
          "other": "Metical Mozambique (1980–2006)"
        },
        "narrow": "MZM",
        "symbol": "MZM"
      },
      "MZN": {
        "displayName": {
          "other": "Metikal Mozambique"
        },
        "narrow": "MZN",
        "symbol": "MZN"
      },
      "NAD": {
        "displayName": {
          "other": "Dolar Namibia"
        },
        "narrow": "$",
        "symbol": "NAD"
      },
      "NGN": {
        "displayName": {
          "other": "Naira Nigeria"
        },
        "narrow": "₦",
        "symbol": "NGN"
      },
      "NIO": {
        "displayName": {
          "other": "Cordoba Nicaragua"
        },
        "narrow": "C$",
        "symbol": "NIO"
      },
      "NOK": {
        "displayName": {
          "other": "Krone Norway"
        },
        "narrow": "kr",
        "symbol": "NOK"
      },
      "NPR": {
        "displayName": {
          "other": "Rupee Nepal"
        },
        "narrow": "Rs",
        "symbol": "NPR"
      },
      "NZD": {
        "displayName": {
          "other": "Dolar New Zealand"
        },
        "narrow": "$",
        "symbol": "NZ$"
      },
      "OMR": {
        "displayName": {
          "other": "Rial Oman"
        },
        "narrow": "OMR",
        "symbol": "OMR"
      },
      "PAB": {
        "displayName": {
          "other": "Balboa Panama"
        },
        "narrow": "PAB",
        "symbol": "PAB"
      },
      "PEN": {
        "displayName": {
          "other": "Sol Peru"
        },
        "narrow": "PEN",
        "symbol": "PEN"
      },
      "PGK": {
        "displayName": {
          "other": "Kina Papua New Guinea"
        },
        "narrow": "PGK",
        "symbol": "PGK"
      },
      "PHP": {
        "displayName": {
          "other": "Peso Filipina"
        },
        "narrow": "₱",
        "symbol": "PHP"
      },
      "PKR": {
        "displayName": {
          "other": "Rupee Pakistan"
        },
        "narrow": "Rs",
        "symbol": "PKR"
      },
      "PLN": {
        "displayName": {
          "other": "Zloty Poland"
        },
        "narrow": "zł",
        "symbol": "PLN"
      },
      "PYG": {
        "displayName": {
          "other": "Guarani Paraguay"
        },
        "narrow": "₲",
        "symbol": "PYG"
      },
      "QAR": {
        "displayName": {
          "other": "Rial Qatar"
        },
        "narrow": "QAR",
        "symbol": "QAR"
      },
      "RHD": {
        "displayName": {
          "other": "Dolar Rhodesia"
        },
        "narrow": "RHD",
        "symbol": "RHD"
      },
      "RON": {
        "displayName": {
          "other": "Leu Romania"
        },
        "narrow": "lei",
        "symbol": "RON"
      },
      "RSD": {
        "displayName": {
          "other": "Dinar Serbia"
        },
        "narrow": "RSD",
        "symbol": "RSD"
      },
      "RUB": {
        "displayName": {
          "other": "Rubel Rusia"
        },
        "narrow": "₽",
        "symbol": "RUB"
      },
      "RUR": {
        "displayName": {
        },
        "narrow": "RUR",
        "symbol": "RUR"
      },
      "RWF": {
        "displayName": {
          "other": "Franc Rwanda"
        },
        "narrow": "RF",
        "symbol": "RWF"
      },
      "SAR": {
        "displayName": {
          "other": "Riyal Saudi"
        },
        "narrow": "SAR",
        "symbol": "SAR"
      },
      "SBD": {
        "displayName": {
          "other": "Dolar Kepulauan Solomon"
        },
        "narrow": "$",
        "symbol": "SBD"
      },
      "SCR": {
        "displayName": {
          "other": "Rupee Seychelles"
        },
        "narrow": "SCR",
        "symbol": "SCR"
      },
      "SDG": {
        "displayName": {
          "other": "Paun Sudan"
        },
        "narrow": "SDG",
        "symbol": "SDG"
      },
      "SEK": {
        "displayName": {
          "other": "Krona Sweden"
        },
        "narrow": "kr",
        "symbol": "SEK"
      },
      "SGD": {
        "displayName": {
          "other": "Dolar Singapura"
        },
        "narrow": "$",
        "symbol": "SGD"
      },
      "SHP": {
        "displayName": {
          "other": "Paun Saint Helena"
        },
        "narrow": "£",
        "symbol": "SHP"
      },
      "SLL": {
        "displayName": {
          "other": "Leone Sierra Leone"
        },
        "narrow": "SLL",
        "symbol": "SLL"
      },
      "SOS": {
        "displayName": {
          "other": "Syiling Somali"
        },
        "narrow": "SOS",
        "symbol": "SOS"
      },
      "SRD": {
        "displayName": {
          "other": "Dolar Surinam"
        },
        "narrow": "$",
        "symbol": "SRD"
      },
      "SSP": {
        "displayName": {
          "other": "Paun Sudan selatan"
        },
        "narrow": "£",
        "symbol": "SSP"
      },
      "STD": {
        "displayName": {
          "other": "Dobra Sao Tome dan Principe (1977–2017)"
        },
        "narrow": "STD",
        "symbol": "STD"
      },
      "STN": {
        "displayName": {
          "other": "Dobra Sao Tome dan Principe"
        },
        "narrow": "Db",
        "symbol": "STN"
      },
      "SYP": {
        "displayName": {
          "other": "Paun Syria"
        },
        "narrow": "£",
        "symbol": "SYP"
      },
      "SZL": {
        "displayName": {
          "other": "Lilangeni Swazi"
        },
        "narrow": "SZL",
        "symbol": "SZL"
      },
      "THB": {
        "displayName": {
          "other": "Baht Thai"
        },
        "narrow": "฿",
        "symbol": "THB"
      },
      "TJS": {
        "displayName": {
          "other": "Somoni Tajikistan"
        },
        "narrow": "TJS",
        "symbol": "TJS"
      },
      "TMT": {
        "displayName": {
          "other": "Manat Turkmenistan"
        },
        "narrow": "TMT",
        "symbol": "TMT"
      },
      "TND": {
        "displayName": {
          "other": "Dinar Tunisia"
        },
        "narrow": "TND",
        "symbol": "TND"
      },
      "TOP": {
        "displayName": {
          "other": "Pa’anga Tonga"
        },
        "narrow": "T$",
        "symbol": "TOP"
      },
      "TRY": {
        "displayName": {
          "other": "Lira Turki"
        },
        "narrow": "₺",
        "symbol": "TRY"
      },
      "TTD": {
        "displayName": {
          "other": "Dolar Trinidad dan Tobago"
        },
        "narrow": "$",
        "symbol": "TTD"
      },
      "TWD": {
        "displayName": {
          "other": "Dolar Taiwan Baru"
        },
        "narrow": "NT$",
        "symbol": "NT$"
      },
      "TZS": {
        "displayName": {
          "other": "Syiling Tanzania"
        },
        "narrow": "TZS",
        "symbol": "TZS"
      },
      "UAH": {
        "displayName": {
          "other": "Hryvnia Ukraine"
        },
        "narrow": "₴",
        "symbol": "UAH"
      },
      "UGS": {
        "displayName": {
          "other": "Shilling Uganda (1966–1987)"
        },
        "narrow": "UGS",
        "symbol": "UGS"
      },
      "UGX": {
        "displayName": {
          "other": "Syiling Uganda"
        },
        "narrow": "UGX",
        "symbol": "UGX"
      },
      "USD": {
        "displayName": {
          "other": "Dolar AS"
        },
        "narrow": "$",
        "symbol": "USD"
      },
      "UYU": {
        "displayName": {
          "other": "Peso Uruguay"
        },
        "narrow": "$",
        "symbol": "UYU"
      },
      "UZS": {
        "displayName": {
          "other": "Som Uzbekistan"
        },
        "narrow": "UZS",
        "symbol": "UZS"
      },
      "VEF": {
        "displayName": {
          "other": "Bolivar Venezuela (2008–2018)"
        },
        "narrow": "Bs",
        "symbol": "VEF"
      },
      "VES": {
        "displayName": {
          "other": "Bolivar Venezuela"
        },
        "narrow": "VES",
        "symbol": "VES"
      },
      "VND": {
        "displayName": {
          "other": "Dong Vietnam"
        },
        "narrow": "₫",
        "symbol": "₫"
      },
      "VUV": {
        "displayName": {
          "other": "Vatu Vanuatu"
        },
        "narrow": "VUV",
        "symbol": "VUV"
      },
      "WST": {
        "displayName": {
          "other": "Tala Samoa"
        },
        "narrow": "WST",
        "symbol": "WST"
      },
      "XAF": {
        "displayName": {
          "other": "Franc CFA BEAC"
        },
        "narrow": "FCFA",
        "symbol": "FCFA"
      },
      "XCD": {
        "displayName": {
          "other": "Dolar Caribbean Timur"
        },
        "narrow": "$",
        "symbol": "EC$"
      },
      "XOF": {
        "displayName": {
          "other": "Franc CFA BCEAO"
        },
        "narrow": "F CFA",
        "symbol": "F CFA"
      },
      "XPF": {
        "displayName": {
          "other": "Franc CFP"
        },
        "narrow": "CFPF",
        "symbol": "CFPF"
      },
      "XXX": {
        "displayName": {
          "other": "(mata wang tidak diketahui)"
        },
        "narrow": "¤",
        "symbol": "¤"
      },
      "YER": {
        "displayName": {
          "other": "Rial Yaman"
        },
        "narrow": "YER",
        "symbol": "YER"
      },
      "ZAR": {
        "displayName": {
          "other": "Rand Afrika Selatan"
        },
        "narrow": "R",
        "symbol": "ZAR"
      },
      "ZMK": {
        "displayName": {
          "other": "Kwacha Zambia (1968–2012)"
        },
        "narrow": "ZMK",
        "symbol": "ZMK"
      },
      "ZMW": {
        "displayName": {
          "other": "Kwacha Zambia"
        },
        "narrow": "ZK",
        "symbol": "ZMW"
      },
      "ZWD": {
        "displayName": {
          "other": "Dolar Zimbabwe (1980–2008)"
        },
        "narrow": "ZWD",
        "symbol": "ZWD"
      },
      "ZWL": {
        "displayName": {
          "other": "Dolar Zimbabwe (2009)"
        },
        "narrow": "ZWL",
        "symbol": "ZWL"
      },
      "ZWR": {
        "displayName": {
          "other": "Dolar Zimbabwe (2008)"
        },
        "narrow": "ZWR",
        "symbol": "ZWR"
      }
    },
    "nu": [
      "latn"
    ],
    "numbers": {
      "currency": {
        "latn": {
          "accounting": "¤#,##0.00;(¤#,##0.00)",
          "currencySpacing": {
            "afterInsertBetween": " ",
            "beforeInsertBetween": " "
          },
          "short": {
            "1000": {
              "other": "¤0K"
            },
            "10000": {
              "other": "¤00K"
            },
            "100000": {
              "other": "¤000K"
            },
            "1000000": {
              "other": "¤0J"
            },
            "10000000": {
              "other": "¤00J"
            },
            "100000000": {
              "other": "¤000J"
            },
            "1000000000": {
              "other": "¤0B"
            },
            "10000000000": {
              "other": "¤00B"
            },
            "100000000000": {
              "other": "¤000B"
            },
            "1000000000000": {
              "other": "¤0T"
            },
            "10000000000000": {
              "other": "¤00T"
            },
            "100000000000000": {
              "other": "¤000T"
            }
          },
          "standard": "¤#,##0.00",
          "unitPattern": "{0} {1}"
        }
      },
      "decimal": {
        "latn": {
          "long": {
            "1000": {
              "other": "0 ribu"
            },
            "10000": {
              "other": "00 ribu"
            },
            "100000": {
              "other": "000 ribu"
            },
            "1000000": {
              "other": "0 juta"
            },
            "10000000": {
              "other": "00 juta"
            },
            "100000000": {
              "other": "000 juta"
            },
            "1000000000": {
              "other": "0 bilion"
            },
            "10000000000": {
              "other": "00 bilion"
            },
            "100000000000": {
              "other": "000 bilion"
            },
            "1000000000000": {
              "other": "0 trilion"
            },
            "10000000000000": {
              "other": "00 trilion"
            },
            "100000000000000": {
              "other": "000 trilion"
            }
          },
          "short": {
            "1000": {
              "other": "0K"
            },
            "10000": {
              "other": "00K"
            },
            "100000": {
              "other": "000K"
            },
            "1000000": {
              "other": "0J"
            },
            "10000000": {
              "other": "00J"
            },
            "100000000": {
              "other": "000J"
            },
            "1000000000": {
              "other": "0B"
            },
            "10000000000": {
              "other": "00B"
            },
            "100000000000": {
              "other": "000B"
            },
            "1000000000000": {
              "other": "0T"
            },
            "10000000000000": {
              "other": "00T"
            },
            "100000000000000": {
              "other": "000T"
            }
          },
          "standard": "#,##0.###"
        }
      },
      "nu": [
        "latn"
      ],
      "percent": {
        "latn": "#,##0%"
      },
      "symbols": {
        "latn": {
          "approximatelySign": "~",
          "decimal": ".",
          "exponential": "E",
          "group": ",",
          "infinity": "∞",
          "list": ";",
          "minusSign": "-",
          "nan": "NaN",
          "perMille": "‰",
          "percentSign": "%",
          "plusSign": "+",
          "rangeSign": "–",
          "superscriptingExponent": "×",
          "timeSeparator": ":"
        }
      }
    },
    "units": {
      "compound": {
        "per": {
          "long": "{0} per {1}",
          "narrow": "{0}/{1}",
          "short": "{0}/{1}"
        }
      },
      "simple": {
        "acre": {
          "long": {
            "other": "{0} ekar"
          },
          "narrow": {
            "other": "{0} ekar"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ekar"
          }
        },
        "bit": {
          "long": {
            "other": "{0} bit"
          },
          "narrow": {
            "other": "{0}bit"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} bit"
          }
        },
        "byte": {
          "long": {
            "other": "{0} bait"
          },
          "narrow": {
            "other": "{0}B"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} bait"
          }
        },
        "celsius": {
          "long": {
            "other": "{0} darjah Celsius"
          },
          "narrow": {
            "other": "{0}°C"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°C"
          }
        },
        "centimeter": {
          "long": {
            "other": "{0} sentimeter"
          },
          "narrow": {
            "other": "{0} cm"
          },
          "perUnit": {
            "long": "{0} setiap sentimeter",
            "narrow": "{0}/cm",
            "short": "{0}/cm"
          },
          "short": {
            "other": "{0} cm"
          }
        },
        "day": {
          "long": {
            "other": "{0} hari"
          },
          "narrow": {
            "other": "{0} h"
          },
          "perUnit": {
            "long": "{0} setiap hari",
            "narrow": "{0}/h",
            "short": "{0}/h"
          },
          "short": {
            "other": "{0} hari"
          }
        },
        "degree": {
          "long": {
            "other": "{0} darjah"
          },
          "narrow": {
            "other": "{0}°"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} darjah"
          }
        },
        "fahrenheit": {
          "long": {
            "other": "{0} darjah Fahrenheit"
          },
          "narrow": {
            "other": "{0}°F"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}°F"
          }
        },
        "fluid-ounce": {
          "long": {
            "other": "{0} auns cecair"
          },
          "narrow": {
            "other": "{0}fl oz"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} fl oz"
          }
        },
        "foot": {
          "long": {
            "other": "{0} kaki"
          },
          "narrow": {
            "other": "{0}'"
          },
          "perUnit": {
            "long": "{0} sekaki",
            "narrow": "{0}/ka",
            "short": "{0}/ka"
          },
          "short": {
            "other": "{0} ka"
          }
        },
        "gallon": {
          "long": {
            "other": "{0} gelen"
          },
          "narrow": {
            "other": "{0} gal"
          },
          "perUnit": {
            "long": "{0} segelen",
            "narrow": "{0}/gal",
            "short": "{0}/gal"
          },
          "short": {
            "other": "{0} gal"
          }
        },
        "gigabit": {
          "long": {
            "other": "{0} gigabit"
          },
          "narrow": {
            "other": "{0}Gb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Gb"
          }
        },
        "gigabyte": {
          "long": {
            "other": "{0} gigabait"
          },
          "narrow": {
            "other": "{0}GB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} GB"
          }
        },
        "gram": {
          "long": {
            "other": "{0} gram"
          },
          "narrow": {
            "other": "{0} g"
          },
          "perUnit": {
            "long": "{0} setiap gram",
            "narrow": "{0}/g",
            "short": "{0}/g"
          },
          "short": {
            "other": "{0} g"
          }
        },
        "hectare": {
          "long": {
            "other": "{0} hektar"
          },
          "narrow": {
            "other": "{0} ha"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ha"
          }
        },
        "hour": {
          "long": {
            "other": "{0} jam"
          },
          "narrow": {
            "other": "{0} j"
          },
          "perUnit": {
            "long": "{0} sejam",
            "narrow": "{0}/j",
            "short": "{0}/j"
          },
          "short": {
            "other": "{0} j"
          }
        },
        "inch": {
          "long": {
            "other": "{0} inci"
          },
          "narrow": {
            "other": "{0}\""
          },
          "perUnit": {
            "long": "{0} seinci",
            "narrow": "{0}/in",
            "short": "{0}/in"
          },
          "short": {
            "other": "{0} in"
          }
        },
        "kilobit": {
          "long": {
            "other": "{0} kilobit"
          },
          "narrow": {
            "other": "{0}kb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kb"
          }
        },
        "kilobyte": {
          "long": {
            "other": "{0} kilobait"
          },
          "narrow": {
            "other": "{0}kB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kB"
          }
        },
        "kilogram": {
          "long": {
            "other": "{0} kilogram"
          },
          "narrow": {
            "other": "{0} kg"
          },
          "perUnit": {
            "long": "{0} setiap kilogram",
            "narrow": "{0}/kg",
            "short": "{0}/kg"
          },
          "short": {
            "other": "{0} kg"
          }
        },
        "kilometer": {
          "long": {
            "other": "{0} kilometer"
          },
          "narrow": {
            "other": "{0} km"
          },
          "perUnit": {
            "long": "{0} setiap kilometer",
            "narrow": "{0}/km",
            "short": "{0}/km"
          },
          "short": {
            "other": "{0} km"
          }
        },
        "kilometer-per-hour": {
          "long": {
            "other": "{0} kilometer sejam"
          },
          "narrow": {
            "other": "{0} kmj"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} kmj"
          }
        },
        "liter": {
          "long": {
            "other": "{0} liter"
          },
          "narrow": {
            "other": "{0} l"
          },
          "perUnit": {
            "long": "{0} setiap liter",
            "narrow": "{0}/l",
            "short": "{0}/l"
          },
          "short": {
            "other": "{0} l"
          }
        },
        "liter-per-kilometer": {
          "long": {
            "other": "{0} liter sekilometer"
          },
          "narrow": {
            "other": "{0} L/km"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} L/km"
          }
        },
        "megabit": {
          "long": {
            "other": "{0} megabit"
          },
          "narrow": {
            "other": "{0}Mb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Mb"
          }
        },
        "megabyte": {
          "long": {
            "other": "{0} megabait"
          },
          "narrow": {
            "other": "{0}MB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} MB"
          }
        },
        "meter": {
          "long": {
            "other": "{0} meter"
          },
          "narrow": {
            "other": "{0} m"
          },
          "perUnit": {
            "long": "{0} setiap meter",
            "narrow": "{0}/m",
            "short": "{0}/m"
          },
          "short": {
            "other": "{0} m"
          }
        },
        "meter-per-second": {
          "long": {
            "other": "{0} meter sesaat"
          },
          "narrow": {
            "other": "{0} m/s"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} m/s"
          }
        },
        "mile": {
          "long": {
            "other": "{0} batu"
          },
          "narrow": {
            "other": "{0} bt"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} bt"
          }
        },
        "mile-per-gallon": {
          "long": {
            "other": "{0} batu segelen"
          },
          "narrow": {
            "other": "{0} bpg"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} bpg"
          }
        },
        "mile-per-hour": {
          "long": {
            "other": "{0} batu sejam"
          },
          "narrow": {
            "other": "{0} bsj"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} bsj"
          }
        },
        "mile-scandinavian": {
          "long": {
            "other": "{0} batu-skandinavia"
          },
          "narrow": {
            "other": "{0} smi"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} smi"
          }
        },
        "milliliter": {
          "long": {
            "other": "{0} mililiter"
          },
          "narrow": {
            "other": "{0} mL"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mL"
          }
        },
        "millimeter": {
          "long": {
            "other": "{0} milimeter"
          },
          "narrow": {
            "other": "{0} mm"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} mm"
          }
        },
        "millisecond": {
          "long": {
            "other": "{0} milisaat"
          },
          "narrow": {
            "other": "{0} ms"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ms"
          }
        },
        "minute": {
          "long": {
            "other": "{0} minit"
          },
          "narrow": {
            "other": "{0} min"
          },
          "perUnit": {
            "long": "{0} setiap minit",
            "narrow": "{0}/min",
            "short": "{0}/min"
          },
          "short": {
            "other": "{0} min"
          }
        },
        "month": {
          "long": {
            "other": "{0} bulan"
          },
          "narrow": {
            "other": "{0} bln"
          },
          "perUnit": {
            "long": "{0} setiap bulan",
            "narrow": "{0}/bln",
            "short": "{0}/bln"
          },
          "short": {
            "other": "{0} bln"
          }
        },
        "ounce": {
          "long": {
            "other": "{0} auns"
          },
          "narrow": {
            "other": "{0} auns"
          },
          "perUnit": {
            "long": "{0} setiap auns",
            "narrow": "{0}/oz",
            "short": "{0}/oz"
          },
          "short": {
            "other": "{0} oz"
          }
        },
        "percent": {
          "long": {
            "other": "{0} peratus"
          },
          "narrow": {
            "other": "{0}%"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0}%"
          }
        },
        "petabyte": {
          "long": {
            "other": "{0} petabait"
          },
          "narrow": {
            "other": "{0}PB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} PB"
          }
        },
        "pound": {
          "long": {
            "other": "{0} paun"
          },
          "narrow": {
            "other": "{0} paun"
          },
          "perUnit": {
            "long": "{0} setiap paun",
            "narrow": "{0}/lb",
            "short": "{0}/lb"
          },
          "short": {
            "other": "{0} lb"
          }
        },
        "second": {
          "long": {
            "other": "{0} saat"
          },
          "narrow": {
            "other": "{0} s"
          },
          "perUnit": {
            "long": "{0} sesaat",
            "narrow": "{0}/s",
            "short": "{0}/s"
          },
          "short": {
            "other": "{0} saat"
          }
        },
        "stone": {
          "long": {
            "other": "{0} stone"
          },
          "narrow": {
            "other": "{0} st"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} st"
          }
        },
        "terabit": {
          "long": {
            "other": "{0} terabit"
          },
          "narrow": {
            "other": "{0}Tb"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} Tb"
          }
        },
        "terabyte": {
          "long": {
            "other": "{0} terabait"
          },
          "narrow": {
            "other": "{0}TB"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} TB"
          }
        },
        "week": {
          "long": {
            "other": "{0} minggu"
          },
          "narrow": {
            "other": "{0} mgu"
          },
          "perUnit": {
            "long": "{0} setiap minggu",
            "narrow": "{0}/mgu",
            "short": "{0}/mgu"
          },
          "short": {
            "other": "{0} mgu"
          }
        },
        "yard": {
          "long": {
            "other": "{0} ela"
          },
          "narrow": {
            "other": "{0} ela"
          },
          "perUnit": {
          },
          "short": {
            "other": "{0} ela"
          }
        },
        "year": {
          "long": {
            "other": "{0} tahun"
          },
          "narrow": {
            "other": "{0} thn"
          },
          "perUnit": {
            "long": "{0} setiap tahun",
            "narrow": "{0}/thn",
            "short": "{0}/thn"
          },
          "short": {
            "other": "{0} thn"
          }
        }
      }
    }
  },
  "locale": "ms"
})
}